import React from "react";
import { Redirect } from "@reach/router";

export default function LoanToolRoot({ documentId }) {
  return <Redirect noThrow to={`/loan-tool/${documentId}/applicant-info`} />;
}
